import { useSelector } from 'react-redux';
import { isRouteOneLender, ROUTE_ONE_LENDER_ID } from 'modules/core/constants/routeOneLenders.const';
import type { ILenderState } from 'store/reducers/lenders.reducer';
import type { RootState } from 'store/store';

const selectLender = (state: RootState): ILenderState => state.lenders.lendersHashTable[state.lenders.currentLenderId];

/** Whether the modal/slider is showing an AmeriCredit deal. `isLender` is required: the lender
 * slice keeps whichever lender was last visited, so the flag alone would fire on a RAC screen too. */
export const useIsAmeriCreditLender = (isLender: boolean): boolean => {
  const lender = useSelector(selectLender);

  return isLender && isRouteOneLender(lender?.route_one_id, ROUTE_ONE_LENDER_ID.AMERICREDIT);
};
